import ACTIONS from '@/store/storeActions';
import LoadingState from '@/api/LoadingState';
import ScheduleEntryTypes from '@/libs/constants';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isEqual from 'lodash.isequal';

dayjs.extend(isSameOrBefore);

const mutations = {
  [ACTIONS.SET_RUN_INFO]: (state, payload) => {
    // initial setup on personalization
    const {
      runInformation,
      timetable,
      exercises,
      candidate
    } = payload;

    const mergeArray = (...arrays) => {
      let jointArray = [];
      arrays.forEach( (array) => {
        jointArray = [...jointArray, ...array]
      })
      const uniqueArray = jointArray.reduce((newArray, item, index) => {
        if (newArray.findIndex((arr) => isEqual(arr, item)) === -1) return [...newArray, item]
        return newArray
      }, [])

      return uniqueArray
    }
    // depending on which of those exist in the incoming request, update the state
    if (runInformation) {
      state.runInformation = { ...state.runInformation, ...runInformation }
    }

    if (exercises && Array.isArray(exercises)) state.exercises = mergeArray(state.exercises, exercises)
    if (candidate) state.candidate = { ...state.candidate, ...candidate }
    if (timetable && Array.isArray(timetable)) {
      state.loadingState = { ...state.loadingState, timetable: LoadingState.LOADING }
      // add to existing timetable if new objects appear
      let timetableEarliestStart = 7;
      const tmp = timetable.map((entry) => {
        /* eslint-disable no-param-reassign */
        switch ( entry.scheduleEntryType ) {
          case ScheduleEntryTypes.PREPARATION:
            entry.color = '#229954'
            break;
          case ScheduleEntryTypes.EXERCISE:
            entry.color = '#2E86C1'
            break;
          case ScheduleEntryTypes.EVALUATION:
          default:
            entry.color = '#ca6f1e'
            break;
        }
        entry.startTime = dayjs(entry.startTime).format('YYYY-MM-DD HH:mm:ss')
        entry.endTime = dayjs(entry.endTime).format('YYYY-MM-DD HH:mm:ss')
        const startingHour = dayjs(entry.startTime).hour();
        if (startingHour < timetableEarliestStart) timetableEarliestStart = entry.startTime.hour()
        /* eslint-enable no-param-reassign */
        return entry;
      })
      state.timetable = mergeArray(state.timetable, tmp);
      state.timetable.sort((a, b) => dayjs(a.startTime).isSameOrBefore(dayjs(b.startTime)))
      if (dayjs(state.timetable[0].startTime).hour() < state.candidate.earliestEventHour) state.candidate = { ...state.candidate, earliestEventHour: state.timetable[0].hour() }
      state.loadingState = { ...state.loadingState, timetable: LoadingState.LOADED }
    }
    state.runState = state.runInformation.runState;
    state.loadingState = { ...state.loadingState, runInformation: LoadingState.LOADED }
  },
  // used for new getCandidateStatus Endpoint
  [ACTIONS.SET_CANDIDATE_STATUS]: (state, payload) => {
    if (payload.candidate) state.candidate = { ...state.candidate, ...payload.candidate };
  },
  // used for new getCandidateRuninformation Endpoint
  [ACTIONS.SET_CANDIDATE_RUN_INFO]: (state, payload) => {
    if (payload.runInformation) {
      state.runInformation = { ...state.runInformation, ...payload.runInformation };
      state.runState = payload.runInformation.runState
    }
  },
  [ACTIONS.SET_RUN_STATE]: (state, payload) => {
    state.runInfo.runInformation.runState = payload;
    state.runState = payload;
  },
  [ACTIONS.UPDATE_RUN_STATE]: (state, { runState }) => {
    state.runState = runState;
    state.runInfo.runInformation.runState = runState;
  },
  [ACTIONS.SET_RUN_INFO_LOADINGSTATE]: (state, { type, loadingState }) => {
    state.loadingState = { ...state.loadingState, [type]: loadingState }
  },
  [ACTIONS.SET_CURRENT_EXERCISE]: (state, payload) => {
    state.currentExerciseId = payload
    state.currentExerciseDocumentsLoadingState = LoadingState.INITIAL;
  },
  [ACTIONS.SET_CANDIDATE_EXERCISE_STATUS_LOADINGSTATE]: (state, payload) => {
    state.loadingState = { ...state.loadingState, openExerciseStatus: payload }
  },
  [ACTIONS.SET_OPEN_EXERCISE_ID]: (state, payload) => {
    state.openExerciseId = payload;
  },
  [ACTIONS.SET_RUN_DOCUMENTS]: (state, payload) => {
    state.runDocuments = payload;
    state.loadingState = { ...state.loadingState, runDocuments: LoadingState.LOADED }
  }
}

export default mutations
